import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Dealer } from '../models/entities/dealer';
import { VDealer } from '../models/entities/v-dealer';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  constructor(private httpClient: HttpClient) { }

  getList(): Observable<ListResponseModel<VDealer>> {
    return this.httpClient.get<ListResponseModel<VDealer>>(ApiUrl.url + "Dealer/getList");
  }

  getDealersByCustomerId(customerId: number): Observable<ListResponseModel<VDealer>> {
    return this.httpClient.get<ListResponseModel<VDealer>>(ApiUrl.url + "Dealer/getDealersByCustomerId?customerId=" + customerId);
  }

  getById(id: number): Observable<ObjectResponseModel<VDealer>> {
    return this.httpClient.get<ObjectResponseModel<VDealer>>(ApiUrl.url + "Dealer/getById?Id=" + id);
  }

  add(dealer: Dealer) {
    return this.httpClient.post<ObjectResponseModel<Dealer>>(ApiUrl.url + "Dealer/add", dealer);
  }

  update(dealer: Dealer) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Dealer/update", dealer);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Dealer/delete?Id=" + id, "");
  }

  

}
